// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Fixes for Layout and Cursor Issues */

/* Fix cursor positioning issues throughout the application */
.clickable,
button,
[role="button"],
input[type="button"],
input[type="submit"],
input[type="reset"],
a,
.nav-link,
.action-item,
.product-card,
.category-item,
.menu-item {
    cursor: pointer !important;
    pointer-events: auto !important;
    position: relative;
    z-index: 1;
}

/* Ensure proper cursor for interactive elements */
.search-button,
.all-products-btn,
.mobile-menu-icon,
.close-button,
.cart-count {
    cursor: pointer !important;
}

/* Fix top-right corner alignment issues */
.side-actions,
.user-actions,
.contact-info {
    position: relative;
    z-index: 10;
    pointer-events: auto;
}

.action-item:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    transition: background-color 0.2s ease;
}

/* Fix header layout alignment */
.shop-header * {
    box-sizing: border-box;
}

.top-bar {
    position: relative;
    z-index: 5;
}

.bottom-nav {
    position: relative;
    z-index: 4;
}

/* Fix main content alignment */
.homepage {
    position: relative;
    min-height: 100vh;
    width: 100%;
}

.main-content {
    position: relative;
    z-index: 1;
}

/* Fix grid alignment issues */
.hero-section {
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.hero-main,
.hero-side {
    position: relative;
    box-sizing: border-box;
}

.hero-side-item {
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
}

/* Fix product grid alignment */
.product-grid {
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.product-card {
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.product-card:hover {
    transform: translateY(-2px);
}

/* Fix modal and overlay positioning */
.login-panel-overlay,
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
}

.login-panel,
.modal {
    position: fixed;
    z-index: 10000;
}

/* Fix category popup alignment */
.category-popup {
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    box-sizing: border-box;
}

.category-grid-container {
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.category-item {
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
}

/* Fix responsive alignment issues */
@media (max-width: 1024px) {
    .top-bar {
        padding: 15px 20px;
    }
    
    .main-content {
        padding: 0 20px;
    }
    
    .side-actions {
        gap: 20px;
    }
    
    .user-actions {
        gap: 15px;
    }
}

@media (max-width: 768px) {
    .top-bar {
        padding: 10px 15px;
    }
    
    .main-content {
        padding: 0 15px;
    }
    
    .side-actions {
        gap: 15px;
    }
    
    .user-actions {
        gap: 10px;
    }
    
    /* Fix mobile cursor issues */
    .mobile-header-actions .action-item {
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
    }
    
    /* Fix mobile touch targets */
    .action-item,
    button,
    .nav-link {
        min-height: 44px;
        min-width: 44px;
    }
}

/* Fix scrolling issues */
html {
    scroll-behavior: smooth;
    overflow-x: hidden;
}

body {
    overflow-x: hidden;
    position: relative;
}

/* Fix text selection issues */
.action-item,
.nav-link,
.category-item {
    -webkit-user-select: none;
    user-select: none;
}

/* Fix focus states */
*:focus {
    outline: 2px solid #E84100;
    outline-offset: 2px;
}

button:focus,
.action-item:focus {
    outline: 2px solid #E84100;
    outline-offset: 2px;
}

/* Fix pointer events for overlays */
.category-popup-overlay {
    pointer-events: auto;
    cursor: default;
}

.category-popup {
    pointer-events: auto;
}

/* Ensure all interactive elements have proper cursor */
svg {
    pointer-events: none;
}

.icon-wrapper svg {
    pointer-events: none;
}

.icon-wrapper {
    cursor: pointer;
    pointer-events: auto;
} `, "",{"version":3,"sources":["webpack://./src/components/css/GlobalFixes.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C,6DAA6D;AAC7D;;;;;;;;;;;;IAYI,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,UAAU;AACd;;AAEA,kDAAkD;AAClD;;;;;IAKI,0BAA0B;AAC9B;;AAEA,0CAA0C;AAC1C;;;IAGI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,gCAAgC;AAChC;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,sCAAsC;AACtC;;IAEI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA,6BAA6B;IAC7B;QACI,eAAe;QACf,+CAA+C;IACnD;;IAEA,6BAA6B;IAC7B;;;QAGI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,yBAAyB;AACzB;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;;;IAGI,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,uDAAuD;AACvD;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB","sourcesContent":["/* Global Fixes for Layout and Cursor Issues */\n\n/* Fix cursor positioning issues throughout the application */\n.clickable,\nbutton,\n[role=\"button\"],\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"],\na,\n.nav-link,\n.action-item,\n.product-card,\n.category-item,\n.menu-item {\n    cursor: pointer !important;\n    pointer-events: auto !important;\n    position: relative;\n    z-index: 1;\n}\n\n/* Ensure proper cursor for interactive elements */\n.search-button,\n.all-products-btn,\n.mobile-menu-icon,\n.close-button,\n.cart-count {\n    cursor: pointer !important;\n}\n\n/* Fix top-right corner alignment issues */\n.side-actions,\n.user-actions,\n.contact-info {\n    position: relative;\n    z-index: 10;\n    pointer-events: auto;\n}\n\n.action-item:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    transition: background-color 0.2s ease;\n}\n\n/* Fix header layout alignment */\n.shop-header * {\n    box-sizing: border-box;\n}\n\n.top-bar {\n    position: relative;\n    z-index: 5;\n}\n\n.bottom-nav {\n    position: relative;\n    z-index: 4;\n}\n\n/* Fix main content alignment */\n.homepage {\n    position: relative;\n    min-height: 100vh;\n    width: 100%;\n}\n\n.main-content {\n    position: relative;\n    z-index: 1;\n}\n\n/* Fix grid alignment issues */\n.hero-section {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.hero-main,\n.hero-side {\n    position: relative;\n    box-sizing: border-box;\n}\n\n.hero-side-item {\n    position: relative;\n    box-sizing: border-box;\n    cursor: pointer;\n}\n\n/* Fix product grid alignment */\n.product-grid {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.product-card {\n    position: relative;\n    box-sizing: border-box;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n.product-card:hover {\n    transform: translateY(-2px);\n}\n\n/* Fix modal and overlay positioning */\n.login-panel-overlay,\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 9999;\n}\n\n.login-panel,\n.modal {\n    position: fixed;\n    z-index: 10000;\n}\n\n/* Fix category popup alignment */\n.category-popup {\n    position: fixed;\n    left: 0;\n    right: 0;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.category-grid-container {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.category-item {\n    cursor: pointer;\n    position: relative;\n    box-sizing: border-box;\n}\n\n/* Fix responsive alignment issues */\n@media (max-width: 1024px) {\n    .top-bar {\n        padding: 15px 20px;\n    }\n    \n    .main-content {\n        padding: 0 20px;\n    }\n    \n    .side-actions {\n        gap: 20px;\n    }\n    \n    .user-actions {\n        gap: 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    .top-bar {\n        padding: 10px 15px;\n    }\n    \n    .main-content {\n        padding: 0 15px;\n    }\n    \n    .side-actions {\n        gap: 15px;\n    }\n    \n    .user-actions {\n        gap: 10px;\n    }\n    \n    /* Fix mobile cursor issues */\n    .mobile-header-actions .action-item {\n        cursor: pointer;\n        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);\n    }\n    \n    /* Fix mobile touch targets */\n    .action-item,\n    button,\n    .nav-link {\n        min-height: 44px;\n        min-width: 44px;\n    }\n}\n\n/* Fix scrolling issues */\nhtml {\n    scroll-behavior: smooth;\n    overflow-x: hidden;\n}\n\nbody {\n    overflow-x: hidden;\n    position: relative;\n}\n\n/* Fix text selection issues */\n.action-item,\n.nav-link,\n.category-item {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n/* Fix focus states */\n*:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 2px;\n}\n\nbutton:focus,\n.action-item:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 2px;\n}\n\n/* Fix pointer events for overlays */\n.category-popup-overlay {\n    pointer-events: auto;\n    cursor: default;\n}\n\n.category-popup {\n    pointer-events: auto;\n}\n\n/* Ensure all interactive elements have proper cursor */\nsvg {\n    pointer-events: none;\n}\n\n.icon-wrapper svg {\n    pointer-events: none;\n}\n\n.icon-wrapper {\n    cursor: pointer;\n    pointer-events: auto;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
